import React, { useState } from "react";
import { Box, Button, TextField } from "@mui/material";
import FlexBetween from "./FlexBetween";

export default function ProductPriceForm({
  enableSubmit,
  onSubmit = () => {},
}) {
  const [form, setForm] = useState({});

  const handleChange = (field, value) => {
    setForm({ [field]: value });
  };

  const handleSubmit = () => {
    onSubmit(form);
  };

  return (
    <Box>
      <Box
        sx={{
          display: "flex",
          gap: 2,
          flexWrap: "wrap",
        }}
      >
        <TextField
          label="prix personnalisé"
          type="number"
          onChange={(event) => handleChange("custom", event.target.value)}
          size="small"
          value={form.custom ?? ""}
          placeholder="Prix personnalisé"
          slotProps={{ htmlInput: { min: 0, step: "0.01" } }}
        />
        <FlexBetween width="100%" gap={2}>
          <TextField
            fullWidth
            label="Remise (%)"
            type="number"
            onChange={(event) =>
              handleChange("remisePercent", event.target.value)
            }
            size="small"
            value={form.remisePercent ?? ""}
            placeholder="Remise (%)"
            slotProps={{ htmlInput: { min: 0, step: "0.01" } }}
          />
          <TextField
            fullWidth
            label="Remise (€)"
            type="number"
            onChange={(event) => handleChange("remiseEuro", event.target.value)}
            size="small"
            value={form.remiseEuro ?? ""}
            placeholder="Remise (€)"
            slotProps={{ htmlInput: { min: 0, step: "0.01" } }}
          />
        </FlexBetween>
        <FlexBetween width="100%" gap={2}>
          <TextField
            fullWidth
            label="Augmentation (%)"
            type="number"
            onChange={(event) =>
              handleChange("augmentationPercent", event.target.value)
            }
            size="small"
            value={form.augmentationPercent ?? ""}
            placeholder="Augmentation (%)"
            slotProps={{ htmlInput: { min: 0, step: "0.01" } }}
          />
          <TextField
            fullWidth
            label="Augmentation (€)"
            type="number"
            onChange={(event) =>
              handleChange("augmentationEuro", event.target.value)
            }
            size="small"
            value={form.augmentationEuro ?? ""}
            placeholder="Augmentation (€)"
            slotProps={{ htmlInput: { min: 0, step: "0.01" } }}
          />
        </FlexBetween>
      </Box>
      <Box sx={{ mt: 2, display: "flex", justifyContent: "flex-end" }}>
        <Button
          variant="contained"
          disabled={!enableSubmit}
          onClick={handleSubmit}
        >
          Appliquer
        </Button>
      </Box>
    </Box>
  );
}
